export default "__VITE_ASSET__62d4d178__"